module.exports = __webpack_public_path__ + "img/markout_dark.1d71ea1a.png";